/* =========================================================
   Kornerprint — Studio de personnalisation (toutes familles)
   Boîtes, plateaux, gobelets & pots, sacs, serviettes, papiers,
   rince-doigts, tapis, porte-menus : dépôt du logo, placement par face,
   aperçu 3D (three.js)
   ========================================================= */
(function () {
  'use strict';
  var THREE_URL = 'https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var clamp = function (v, a, b) { return Math.max(a, Math.min(b, v)); };
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var PI = Math.PI;

  var INKS = [
    { name: 'Noir', hex: '#1d1d1f' }, { name: 'Rouge', hex: '#c8102e' }, { name: 'Vert', hex: '#2e7d32' },
    { name: 'Bleu', hex: '#1f3a93' }, { name: 'Bordeaux', hex: '#7b1e2b' }, { name: 'Orange', hex: '#e8641b' },
    { name: 'Blanc', hex: '#ffffff' }, { name: 'Or', hex: '#c9a44c' }, { name: 'Argent', hex: '#bfc3c7' }
  ];
  /* teintes de support */
  var MAT = {
    white: { label: 'Blanc', base: '#f4f2ed', dot: '#f4f2ed' },
    kraft: { label: 'Kraft', base: '#b98b5b', dot: '#b98b5b' },
    black: { label: 'Noir', base: '#222224', dot: '#222224', dark: true },
    frost: { label: 'Givré', base: '#e6ecef', dot: '#e6ecef', clear: true },
    gray: { label: 'Gris', base: '#8b8e92', dot: '#8b8e92', dark: true, carpet: true },
    anthra: { label: 'Anthracite', base: '#3b3e42', dot: '#3b3e42', dark: true, carpet: true },
    navy: { label: 'Bleu marine', base: '#23304a', dot: '#23304a', dark: true, carpet: true },
    cuirnoir: { label: 'Noir', base: '#1f1d1c', dot: '#1f1d1c', dark: true, leather: true },
    cuirbrun: { label: 'Marron', base: '#5a3a26', dot: '#5a3a26', dark: true, leather: true },
    cuirrouge: { label: 'Bordeaux', base: '#5e1a24', dot: '#5e1a24', dark: true, leather: true }
  };

  /* ---------- Familles de produits ---------- */
  var SIDES = [
    { id: 'front', label: 'Avant', long: 'Face avant', up: '↑ haut' },
    { id: 'left', label: 'Gauche', long: 'Côté gauche', up: '↑ haut' },
    { id: 'right', label: 'Droite', long: 'Côté droit', up: '↑ haut' },
    { id: 'back', label: 'Arrière', long: 'Face arrière', up: '↑ haut' }
  ];
  var NOUN = { pizza: 'boîte', patisserie: 'boîte', coffret: 'boîte', food: 'boîte', tray: 'plateau', gobelet: 'gobelet', ecocup: 'gobelet', glace: 'pot', soupe: 'pot', pates: 'pot', bucket: 'pot', wrap: 'pot', saladier: 'saladier', bag: 'sac', cornet: 'cornet', napkin: 'serviette', paper: 'feuille', sachet: 'sachet', mat: 'tapis', menu: 'porte-menu' };
  function facesFor(shape, sub) {
    if (shape === 'box') return [{ id: 'top', label: 'Couvercle', long: 'Couvercle', up: '↑ charnière (arrière)' }].concat(SIDES);
    if (shape === 'tray') return SIDES;
    if (shape === 'cup') return [{ id: 'wrap', label: 'Tour', long: 'Tour du ' + (NOUN[sub] || 'pot'), up: '↑ haut · la bande fait le tour, jointure à l\'arrière' }];
    if (shape === 'bag') return sub === 'cornet'
      ? [{ id: 'front', label: 'Avant', long: 'Face avant', up: '↑ haut du cornet' }, { id: 'back', label: 'Arrière', long: 'Face arrière', up: '↑ haut du cornet' }]
      : [{ id: 'front', label: 'Avant', long: 'Face avant', up: '↑ haut du sac' }, { id: 'back', label: 'Arrière', long: 'Face arrière', up: '↑ haut du sac' },
         { id: 'left', label: 'Soufflet G.', long: 'Soufflet gauche', up: '↑ haut du sac' }, { id: 'right', label: 'Soufflet D.', long: 'Soufflet droit', up: '↑ haut du sac' }];
    var L = { napkin: 'Serviette', paper: 'Feuille', sachet: 'Sachet', mat: 'Tapis', menu: 'Couverture' }[sub] || 'Recto';
    return [{ id: 'recto', label: L, long: L, up: sub === 'mat' ? '↑ fond du tapis (côté porte)' : '↑ haut' }];
  }
  function matsFor(shape, sub) {
    if (sub === 'ecocup') return ['frost', 'white'];
    if (sub === 'mat') return ['gray', 'anthra', 'navy'];
    if (sub === 'menu') return ['cuirnoir', 'cuirbrun', 'cuirrouge'];
    if (sub === 'napkin' || sub === 'paper') return ['white', 'kraft', 'black'];
    return ['white', 'kraft'];
  }
  /* volumes (ml) → Ø haut, Ø bas, hauteur (cm) */
  var CUPS = {
    gobelet: { 118: [6.2, 4.6, 6], 177: [7.3, 5.3, 7.8], 207: [7.3, 5.2, 8], 237: [8, 5.6, 9.2], 355: [9, 6, 11] },
    ecocup: { 250: [7.8, 6, 11.5], 330: [8.3, 6.3, 12.6], 400: [9, 6.6, 14.5], 500: [9.5, 6.8, 16.5] },
    glace: { 100: [7.2, 5.6, 4.2], 140: [7.6, 6, 5], 240: [9.7, 7.6, 5.5], 350: [9.7, 7.4, 7.8], 390: [9.7, 7.4, 8.5] },
    soupe: { 237: [9, 7.3, 6], 358: [9, 7.2, 8.2], 479: [9, 7, 10.5], 770: [11.7, 9.6, 10], 946: [11.7, 9.6, 11.8] },
    saladier: { 500: [15, 12.8, 4.5], 780: [15, 12.8, 6.5], 1000: [15, 12.8, 7.5], 1100: [15, 12.8, 8.2], 1250: [15, 12.8, 9.3], 1300: [15, 12.8, 9.6] },
    pates: { 500: [9.5, 6.5, 10], 750: [10, 7, 12], 960: [10.5, 7.5, 13.5] },
    bucket: { 2500: [18.5, 15, 15], 4500: [22, 18, 18.5] },
    wrap: { 165: [6.5, 5, 10.5] }
  };
  var MEALBOX = { 500: [17, 12, 5], 750: [17, 12, 6.5], 1500: [21.5, 16, 7], 2000: [21.5, 16, 9], 2950: [27, 19, 9] };

  function num(s) { return parseFloat(String(s).replace(',', '.')); }
  function nearest(tbl, v) { var best = null, bd = 1e9; Object.keys(tbl).forEach(function (k) { var d = Math.abs(+k - v); if (d < bd) { bd = d; best = tbl[k]; } }); return best; }
  function volume(str) {
    var s = String(str || ''), m;
    if ((m = s.match(/(\d+(?:[.,]\d+)?)\s*oz/i))) return num(m[1]) * 29.57;
    if ((m = s.match(/(\d+(?:[.,]\d+)?)\s*ml/i))) return num(m[1]);
    if ((m = s.match(/(\d+(?:[.,]\d+)?)(?:\s*\/\s*\d+)?\s*cl/i))) return num(m[1]) * 10;
    if ((m = s.match(/(\d+(?:[.,]\d+)?)\s*l(?:itres?)?\b/i))) return num(m[1]) * 1000;
    return 0;
  }
  function triple(str) {
    var s = String(str || ''), m = s.match(/(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)(?:\s*[x×+]\s*(\d+(?:[.,]\d+)?))?/i);
    if (!m) return null;
    var a = [num(m[1]), num(m[2]), m[3] ? num(m[3]) : null];
    var mm = /mm/i.test(s) || (!/cm/i.test(s) && Math.max(a[0], a[1]) > 60);
    if (mm) a = a.map(function (v) { return v == null ? null : v / 10; });
    return a;
  }
  function bagDims(str) {
    var m = String(str || '').match(/(\d+(?:[.,]\d+)?)\s*\+\s*(\d+(?:[.,]\d+)?)\s*x\s*(\d+(?:[.,]\d+)?)/i);
    return m ? { w: num(m[1]), d: num(m[2]), h: num(m[3]) } : null;
  }
  function isImage(f) { return f && /^image\/(png|jpe?g|svg\+xml|webp|gif)$/i.test(f.type || '') || /\.(png|jpe?g|svg|webp|gif)$/i.test(f && f.name || ''); }
  function fmt(n, d) { return Number(n).toLocaleString('fr-FR', { maximumFractionDigits: d == null ? 1 : d }); }

  function loadThree() {
    if (window.THREE) return Promise.resolve(window.THREE);
    if (loadThree.p) return loadThree.p;
    loadThree.p = new Promise(function (res, rej) {
      var s = document.createElement('script'); s.src = THREE_URL; s.async = true;
      s.onload = function () { res(window.THREE); }; s.onerror = function () { loadThree.p = null; rej(new Error('three')); };
      document.head.appendChild(s);
    });
    return loadThree.p;
  }

  /* ---------- Textures de support (générées, sans image à charger) ---------- */
  function surface(w, h, kind, seed) {
    var M = MAT[kind] || MAT.white;
    var c = document.createElement('canvas'); c.width = w; c.height = h;
    var x = c.getContext('2d');
    x.fillStyle = M.base; x.fillRect(0, 0, w, h);
    var g = x.createLinearGradient(0, 0, w, h);
    g.addColorStop(0, M.dark ? 'rgba(255,255,255,.05)' : 'rgba(255,255,255,.22)');
    g.addColorStop(1, M.dark ? 'rgba(0,0,0,.12)' : 'rgba(0,0,0,.04)');
    x.fillStyle = g; x.fillRect(0, 0, w, h);
    var r = seed || 7; function rnd() { r = (r * 16807) % 2147483647; return r / 2147483647; }
    var kraft = kind === 'kraft', n = Math.round(w * h / (M.carpet ? 40 : kraft ? 90 : 160));
    for (var i = 0; i < n; i++) {
      var px = rnd() * w, py = rnd() * h, len = M.carpet ? 1.5 : 2 + rnd() * (kraft ? 9 : 5), a = rnd() * PI, dark = rnd() > .45;
      if (M.carpet) x.strokeStyle = dark ? 'rgba(0,0,0,' + (.08 + rnd() * .12) + ')' : 'rgba(255,255,255,' + (.04 + rnd() * .08) + ')';
      else if (M.leather) x.strokeStyle = dark ? 'rgba(0,0,0,.18)' : 'rgba(255,255,255,.035)';
      else if (M.dark) x.strokeStyle = dark ? 'rgba(0,0,0,.25)' : 'rgba(255,255,255,.04)';
      else if (kraft) x.strokeStyle = dark ? 'rgba(90,55,25,' + (.05 + rnd() * .12) + ')' : 'rgba(255,225,180,' + (.04 + rnd() * .1) + ')';
      else x.strokeStyle = dark ? 'rgba(0,0,0,' + (.012 + rnd() * .03) + ')' : 'rgba(255,255,255,.5)';
      x.lineWidth = .6 + rnd() * .8;
      x.beginPath(); x.moveTo(px, py); x.lineTo(px + Math.cos(a) * len, py + Math.sin(a) * len); x.stroke();
    }
    return c;
  }
  /* logo converti en 1 encre */
  function inkify(img, hex) {
    var max = 1400, s = Math.min(1, max / Math.max(img.naturalWidth || img.width, img.naturalHeight || img.height));
    var w = Math.max(1, Math.round((img.naturalWidth || img.width) * s)), h = Math.max(1, Math.round((img.naturalHeight || img.height) * s));
    var c = document.createElement('canvas'); c.width = w; c.height = h;
    var x = c.getContext('2d'); x.drawImage(img, 0, 0, w, h);
    var rgb = [parseInt(hex.substr(1, 2), 16), parseInt(hex.substr(3, 2), 16), parseInt(hex.substr(5, 2), 16)];
    try {
      var d = x.getImageData(0, 0, w, h), p = d.data;
      for (var i = 0; i < p.length; i += 4) {
        var lum = (.299 * p[i] + .587 * p[i + 1] + .114 * p[i + 2]) / 255;
        var ink = clamp((0.82 - lum) / 0.3, 0, 1) * (p[i + 3] / 255);
        p[i] = rgb[0]; p[i + 1] = rgb[1]; p[i + 2] = rgb[2]; p[i + 3] = Math.round(ink * 255);
      }
      x.putImageData(d, 0, 0);
    } catch (e) { /* image protégée : on garde l'original */ }
    return c;
  }

  /* =========================================================
     Studio
     ========================================================= */
  function Studio(root, cta, modal) {
    var self = this;
    this.root = root; this.cta = cta; this.modal = modal;
    this.shape = cta.dataset.shape || 'box'; this.sub = cta.dataset.sub || '';
    this.handles = cta.dataset.handles || 'none';
    this.FACES = facesFor(this.shape, this.sub);
    this.MATS = matsFor(this.shape, this.sub);
    this.form = $('form[data-kp-ajax-add]', root);
    this.logoInput = this.form ? $('input[type=file][name="properties[Logo]"]', this.form) : null;
    this.propInput = $('[data-studio-prop]', root);
    this.proofInput = $('[data-studio-proof]', root);
    this.facesInput = $('[data-studio-faces-prop]', root);
    this.material = cta.dataset.material || this.MATS[0];
    if (this.MATS.indexOf(this.material) < 0) this.material = this.MATS[0];
    this.faces = {};
    this.FACES.forEach(function (f, i) { self.faces[f.id] = { on: i === 0, x: .5, y: .5, w: i === 0 ? .55 : .35, rot: 0, rep: 1, tile: false }; });
    this.cur = this.FACES[0].id; this.state = this.faces[this.cur];
    this.cv = {}; this.bases = {}; this.texs = {};
    this.logo = null; this.logoName = ''; this.aspect = 1;
    this.mono = false; this.ink = INKS[0];
    this.lidOpen = false;
    this.setupUI(); this.bind(); this.matFromOptions(true);
    this.syncFromForm();
  }
  var P = Studio.prototype;

  P.option = function (re, not) {
    var g = $$('.kp-opt-group[data-index]', this.root).find(function (el) {
      var n = $('.kp-opt-group__name', el); return n && re.test(n.textContent) && !(not && not.test(n.textContent));
    });
    if (!g) return null;
    var p = $('.kp-pill[aria-checked="true"]', g);
    return p ? p.dataset.value : null;
  };
  P.sizeValue = function () { return this.option(/taille/i) || this.option(/format|dimension/i) || ''; };
  P.colors = function () {
    var v = this.option(/couleur d.impression|^\s*\d*\s*impression/i) || '';
    if (/quadri/i.test(v)) return 4;
    var m = v.match(/(\d+)\s*coul/i); return m ? +m[1] : 0;
  };
  /* support lu dans les options (ex. « Couleur de la serviette : Kraft ») */
  P.matFromOptions = function (init) {
    var v = this.option(/couleur/i, /impression/i); if (!v) return;
    var m = /kraft|kfrat|brun/i.test(v) ? 'kraft' : /noir/i.test(v) ? 'black' : /blanc/i.test(v) ? 'white' : null;
    if (m && this.MATS.indexOf(m) > -1 && m !== this.material) { if (init) this.material = m; else this.setMaterial(m); }
  };

  /* dimensions du produit (cm) */
  P.dims = function () {
    var s = this.sizeValue(), t = this.cta.dataset.title || '', sub = this.sub, a, v, c;
    if (this.shape === 'box' || this.shape === 'tray') {
      if (sub === 'food' && (v = volume(s)) && !triple(s)) { c = nearest(MEALBOX, v); return { w: c[0], d: c[1], h: c[2] }; }
      a = triple(s) || triple(t) || [33, 33, 3.5];
      return { w: a[0], d: a[1], h: a[2] || clamp(Math.min(a[0], a[1]) * .6, 3, 10) };
    }
    if (this.shape === 'cup') {
      var tbl = CUPS[sub] || CUPS.gobelet; v = volume(s) || volume(t);
      c = v ? nearest(tbl, v) : tbl[Object.keys(tbl)[0]];
      return { dt: c[0], db: c[1], h: c[2], w: c[0], d: c[0] };
    }
    if (this.shape === 'bag') {
      if (sub === 'cornet') { a = triple(s) || [8.3, 13, 12.5]; return { w: a[1], d: a[0], h: a[2] || 12.5 }; }
      return bagDims(s) || bagDims(t) || { w: 12, d: 6, h: 30 };
    }
    /* produits plats */
    var m2 = String(s).match(/(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)/i) || String(t).match(/(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)/i);
    if (m2) { var mm = /mm/i.test(s); return { w: num(m2[1]) / (mm ? 10 : 1), d: num(m2[2]) / (mm ? 10 : 1), h: 0 }; }
    if (/a5/i.test(s)) return { w: 14.8, d: 21, h: 0 };
    if (/a4/i.test(s)) return { w: 21, d: 29.7, h: 0 };
    var one = String(s).match(/(\d+(?:[.,]\d+)?)\s*cm/i); if (one) return { w: num(one[1]), d: Math.round(num(one[1]) * 1.4), h: 0 };
    return { napkin: { w: 40, d: 40 }, paper: { w: 35, d: 50 }, sachet: { w: 6, d: 8 }, mat: { w: 60, d: 85 }, menu: { w: 23, d: 32 } }[sub] || { w: 30, d: 30, h: 0 };
  };
  /* dimensions (cm) d'une face imprimée : largeur × hauteur + marge */
  P.fdims = function (id) {
    var d = this.dims(); id = id || this.cur;
    var mk = function (w, h, safe) { return { w: w, h: h, safe: Math.min(safe, Math.min(w, h) * .12) }; };
    switch (this.shape) {
      case 'box': case 'tray':
        if (id === 'top') return mk(d.w, d.d, 1.5);
        return id === 'front' || id === 'back' ? mk(d.w, d.h, .4) : mk(d.d, d.h, .4);
      case 'cup': return mk(PI * (d.dt + d.db) / 2, d.h, .5);
      case 'bag': return id === 'front' || id === 'back' ? mk(d.w, d.h, 1.5) : mk(d.d, d.h, 1);
      default: return mk(d.w, d.d, this.sub === 'sachet' ? .4 : 1);
    }
  };
  P.faceInfo = function (id) { id = id || this.cur; return this.FACES.find(function (f) { return f.id === id; }); };
  P.noun = function () { return NOUN[this.shape === 'bag' && this.sub !== 'cornet' ? 'bag' : this.sub] || (this.shape === 'box' ? 'boîte' : 'produit'); };

  /* vues de caméra (azimut, élévation) */
  P.camFor = function (id) {
    var V = { top: [0, 1.5], front: [0, .3], left: [-PI / 2, .3], right: [PI / 2, .3], back: [PI, .3], wrap: [0, .25], recto: [0, 1.15] };
    return V[id] || this.cam34();
  };
  P.cam34 = function () { return { box: [-.55, .72], tray: [-.55, .72], cup: [-.35, .35], bag: [-.5, .3], flat: [-.35, .85] }[this.shape] || [-.55, .72]; };

  P.setupUI = function () {
    var self = this, bar = $('[data-studio-faces]', this.modal);
    bar.innerHTML = this.FACES.map(function (f, i) { return '<button type="button" role="tab" class="kp-studio__face" data-studio-face="' + f.id + '" aria-selected="' + (i === 0) + '"' + (i ? ' tabindex="-1"' : '') + '>' + f.label + '</button>'; }).join('');
    bar.hidden = this.FACES.length < 2;
    var mats = $('[data-studio-mats]', this.modal);
    mats.innerHTML = this.MATS.map(function (k) { return '<button type="button" class="kp-studio__mat" data-studio-mat="' + k + '" aria-pressed="false"><i style="background:' + MAT[k].dot + '"></i>' + MAT[k].label + '</button>'; }).join('');
    $('#kp-studio-title', this.modal).textContent = 'Personnalisez votre ' + this.noun();
    $('[data-studio-lid]', this.modal).hidden = this.shape !== 'box';
    $('[data-studio-rep-wrap]', this.modal).hidden = this.shape !== 'cup';
    $('[data-studio-tile-wrap]', this.modal).hidden = !(this.shape === 'flat' && /napkin|paper|sachet/.test(this.sub));
    var all = $('[data-studio-allsides]', this.modal);
    all.textContent = this.shape === 'bag' ? 'Reproduire sur l\'autre face' : 'Même placement sur les 4 côtés';
  };
  P.renderFaces = function () {
    var self = this;
    $$('[data-studio-face]', this.modal).forEach(function (b) {
      var id = b.dataset.studioFace;
      b.setAttribute('aria-selected', id === self.cur); b.tabIndex = id === self.cur ? 0 : -1;
      b.classList.toggle('is-on', !!self.faces[id].on);
    });
    var canCopy = (this.shape === 'box' || this.shape === 'tray') ? this.cur !== 'top' : (this.shape === 'bag' && (this.cur === 'front' || this.cur === 'back') && this.faces[this.cur].on);
    $('[data-studio-allsides]', this.modal).hidden = !canCopy;
    var onCount = this.FACES.filter(function (f) { return self.faces[f.id].on; }).length;
    $('[data-studio-remove]', this.modal).hidden = this.FACES.length < 2 || !this.faces[this.cur].on || onCount < 2;
    $$('[data-studio-rep]', this.modal).forEach(function (b) { b.setAttribute('aria-pressed', +b.dataset.studioRep === (self.state.rep || 1)); });
    var tl = $('[data-studio-tile]', this.modal); if (tl) tl.checked = !!this.state.tile;
  };
  P.setFace = function (id) {
    this.cur = id; this.state = this.faces[id];
    this.renderFaces(); this.layoutStage(); this.update();
    if (this.cam) { this.cam.auto = false; this.aim(this.camFor(id)); if (this.lidOpen) this.toggleLid(); }
    $$('[data-studio-view]', this.modal).forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
  };
  P.aim = function (v) { var c = this.cam, n = Math.round((c.tth - v[0]) / (PI * 2)); c.tth = v[0] + n * PI * 2; c.tph = v[1]; };

  P.bind = function () {
    var self = this;
    $$('[data-studio-open]', this.root).forEach(function (b) { b.addEventListener('click', function () { self.open(); }); });
    $$('[data-studio-close]', this.modal).forEach(function (b) { b.addEventListener('click', function () { self.close(); }); });
    this.modal.addEventListener('keydown', function (e) { if (e.key === 'Escape') { e.stopPropagation(); self.close(); } });
    if (this.logoInput) this.logoInput.addEventListener('change', function () { self.loadFile(self.logoInput.files[0], true); });
    var pick = $('[data-studio-file]', this.modal);
    $$('[data-studio-upload]', this.modal).forEach(function (b) { b.addEventListener('click', function () { pick.click(); }); });
    pick.addEventListener('change', function () {
      var f = pick.files[0]; if (!f) return;
      if (self.logoInput) { /* le fichier choisi dans le studio devient le fichier de commande */
        try { var dt = new DataTransfer(); dt.items.add(f); self.logoInput.files = dt.files; self.logoInput.dispatchEvent(new Event('change', { bubbles: true })); }
        catch (e) { self.loadFile(f, false); }
      } else self.loadFile(f, false);
      pick.value = '';
    });
    var drop = $('[data-studio-stage-wrap]', this.modal);
    ['dragenter', 'dragover'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-drag'); }); });
    ['dragleave', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-drag'); }); });
    drop.addEventListener('drop', function (e) { var f = e.dataTransfer.files[0]; if (f) { pick.files = e.dataTransfer.files; pick.dispatchEvent(new Event('change')); } });

    this.size = $('[data-studio-size]', this.modal); this.rotIn = $('[data-studio-rot]', this.modal);
    this.size.addEventListener('input', function () { self.state.w = self.size.value / 100; self.fit(); self.update(); });
    this.rotIn.addEventListener('input', function () { self.state.rot = +self.rotIn.value; self.update(); });
    $('[data-studio-center]', this.modal).addEventListener('click', function () { self.state.x = .5; self.state.y = .5; self.update(); });
    $('[data-studio-rot90]', this.modal).addEventListener('click', function () { var r = self.state.rot + 90; if (r > 180) r -= 360; self.state.rot = r; self.update(); });
    $('[data-studio-reset]', this.modal).addEventListener('click', function () { Object.assign(self.state, { x: .5, y: .5, w: .55, rot: 0, rep: 1, tile: false }); self.fit(); self.renderFaces(); self.update(); });
    var bar = $('[data-studio-faces]', this.modal);
    bar.addEventListener('click', function (e) { var b = e.target.closest('[data-studio-face]'); if (b) self.setFace(b.dataset.studioFace); });
    bar.addEventListener('keydown', function (e) {
      var k = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0; if (!k) return;
      var all = $$('[data-studio-face]', bar), i = all.findIndex(function (b) { return b.dataset.studioFace === self.cur; });
      e.preventDefault(); var n = all[(i + k + all.length) % all.length]; n.click(); n.focus();
    });
    $('[data-studio-add]', this.modal).addEventListener('click', function () { self.state.on = true; self.fit(); self.renderFaces(); self.update(); });
    $('[data-studio-remove]', this.modal).addEventListener('click', function () { self.state.on = false; self.renderFaces(); self.update(); });
    $('[data-studio-allsides]', this.modal).addEventListener('click', function () {
      var src = self.state, targets = self.shape === 'bag' ? [self.cur === 'front' ? 'back' : 'front'] : ['front', 'left', 'right', 'back'];
      targets.forEach(function (id) {
        var f = self.faces[id]; if (!f) return; f.on = true; f.x = src.x; f.y = src.y; f.w = src.w; f.rot = src.rot;
        self.fit(id); self.paint(id);
      });
      self.renderFaces(); self.update();
      self.toast(self.shape === 'bag' ? 'Logo reproduit sur l\'autre face' : 'Logo appliqué sur les 4 côtés');
    });
    $$('[data-studio-rep]', this.modal).forEach(function (b) { b.addEventListener('click', function () { self.state.rep = +b.dataset.studioRep; self.fit(); self.renderFaces(); self.update(); }); });
    var tile = $('[data-studio-tile]', this.modal); if (tile) tile.addEventListener('change', function () { self.state.tile = tile.checked; if (tile.checked && self.state.w > .3) self.state.w = .2; self.fit(); self.update(); });
    $('[data-studio-mono]', this.modal).addEventListener('change', function (e) { self.mono = e.target.checked; self._inkTouched = true; self.renderInks(); self.refreshLogo(); });
    $('[data-studio-mats]', this.modal).addEventListener('click', function (e) { var b = e.target.closest('[data-studio-mat]'); if (b) self.setMaterial(b.dataset.studioMat); });
    $('[data-studio-lid]', this.modal).addEventListener('click', function () { self.toggleLid(); });
    $$('[data-studio-view]', this.modal).forEach(function (b) { b.addEventListener('click', function () { self.view(b.dataset.studioView); }); });
    $('[data-studio-validate]', this.modal).addEventListener('click', function () { self.validate(); });
    $$('[data-studio-edit]', this.root).forEach(function (b) { b.addEventListener('click', function () { self.open(); }); });
    this.initStage();
    /* changement de taille, de support ou d'impression sur la fiche produit */
    this.root.addEventListener('click', function (e) { if (e.target.closest('.kp-pill')) setTimeout(function () { self.matFromOptions(); if (!self.modal.hidden) self.rebuild(); }, 30); });
  };
  P.toast = function (msg) { var t = $('[data-kp-toast]'); if (t) { t.textContent = msg; t.classList.add('is-visible'); clearTimeout(t._s); t._s = setTimeout(function () { t.classList.remove('is-visible'); }, 2400); } };

  P.syncFromForm = function () { if (this.logoInput && this.logoInput.files && this.logoInput.files[0]) this.loadFile(this.logoInput.files[0], true); };
  P.loadFile = function (f, fromForm) {
    var self = this, note = $('[data-studio-note]', this.modal);
    if (!f) return;
    this.logoName = f.name;
    if (!isImage(f)) {
      this.logo = null; this.update();
      note.hidden = false;
      note.innerHTML = '<strong>« ' + f.name.replace(/[<>&]/g, '') + ' » est bien joint à votre commande.</strong> L\'aperçu fonctionne avec un PNG, JPG ou SVG : importez une version image pour visualiser le rendu.';
      this.cta.classList.add('has-file');
      return;
    }
    note.hidden = true;
    var img = new Image();
    img.onload = function () {
      self.logo = img; self.aspect = (img.naturalHeight || img.height) / (img.naturalWidth || img.width) || 1;
      self.FACES.forEach(function (fc) { self.fit(fc.id); }); self.refreshLogo();
      self.cta.classList.add('has-file');
      if (fromForm && self.modal.hidden) { var b = $('[data-studio-open]', self.cta); if (b) { b.classList.remove('is-pulse'); void b.offsetWidth; b.classList.add('is-pulse'); } }
    };
    img.onerror = function () { note.hidden = false; note.textContent = 'Impossible de lire cette image. Essayez un PNG ou un JPG.'; };
    img.src = URL.createObjectURL(f);
  };
  /* garde le logo dans la zone imprimable */
  P.fit = function (id) {
    id = id || this.cur;
    var fd = this.fdims(id), s = this.faces[id], rep = s.rep || 1;
    var maxW = Math.min((fd.w - 2 * fd.safe) / fd.w, rep > 1 ? .9 / rep : 1), maxH = (fd.h - 2 * fd.safe) / fd.h;
    if (s.w * fd.w * this.aspect / fd.h > maxH) s.w = maxH * fd.h / (fd.w * this.aspect);
    s.w = clamp(s.w, .02, maxW);
  };
  P.refreshLogo = function () {
    var self = this;
    this.logoSrc = this.logo ? (this.mono ? inkify(this.logo, this.ink.hex) : this.logo) : null;
    this.FACES.forEach(function (f) { self.paint(f.id); });
    this.update();
  };
  P.renderInks = function () {
    var self = this, box = $('[data-studio-inks]', this.modal);
    box.hidden = !this.mono;
    box.innerHTML = INKS.map(function (k) {
      return '<button type="button" class="kp-studio__ink" style="--c:' + k.hex + '" aria-pressed="' + (k === self.ink) + '" aria-label="Encre ' + k.name + '" title="' + k.name + '"></button>';
    }).join('');
    $$('button', box).forEach(function (b, i) { b.addEventListener('click', function () { self.ink = INKS[i]; self._inkTouched = true; self.renderInks(); self.refreshLogo(); }); });
  };
  P.autoInk = function () {
    /* support foncé : encre claire (ou dorure pour les porte-menus) */
    if (this._inkTouched) return;
    var dark = !!MAT[this.material].dark;
    if (dark) { this.mono = true; this.ink = INKS[this.sub === 'menu' ? 7 : 6]; }
    else if (this.ink.hex === '#ffffff' || this.ink.name === 'Or') { this.ink = INKS[0]; }
    var cb = $('[data-studio-mono]', this.modal); if (cb) cb.checked = this.mono;
  };
  P.setMaterial = function (m) {
    this.material = m; this.bases = {};
    $$('[data-studio-mat]', this.modal).forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.studioMat === m); });
    this.autoInk(); this.renderInks();
    this.logoSrc = this.logo ? (this.mono ? inkify(this.logo, this.ink.hex) : this.logo) : null;
    this.rebuild();
  };

  /* dessine une face (support + logo) : partagé entre la vue 2D et la texture 3D */
  P.paint = function (id) {
    id = id || this.cur;
    var fd = this.fdims(id), big = Math.max(fd.w, fd.h) > 60, TW = id === 'top' || this.shape === 'flat' ? (big ? 1536 : 1024) : 2048;
    var TH = Math.max(8, Math.round(TW * fd.h / fd.w)); if (TH > 4096) { TW = Math.round(TW * 4096 / TH); TH = 4096; }
    var c = this.cv[id];
    if (!c || c.width !== TW || c.height !== TH) { c = this.cv[id] = document.createElement('canvas'); c.width = TW; c.height = TH; this.bases[id] = null; if (this.texs[id]) this.texs[id].image = c; }
    if (!this.bases[id]) this.bases[id] = surface(TW, TH, this.material, 11 + id.length);
    var x = c.getContext('2d'), s = this.faces[id], M = MAT[this.material];
    x.globalCompositeOperation = 'source-over'; x.globalAlpha = 1;
    x.drawImage(this.bases[id], 0, 0);
    if (this.logoSrc && s.on) {
      var lw = s.w * TW, lh = lw * this.aspect, src = this.logoSrc;
      x.globalCompositeOperation = M.dark || M.clear ? 'source-over' : 'multiply';
      x.globalAlpha = this.material === 'kraft' ? .92 : 1;
      var put = function (px, py) { x.save(); x.translate(px, py); x.rotate(s.rot * PI / 180); x.drawImage(src, -lw / 2, -lh / 2, lw, lh); x.restore(); };
      if (s.tile) {
        var sx = Math.max(lw, lh) * 1.9, sy = Math.max(lw, lh) * 1.5, row = 0;
        for (var yy = (s.y * TH) % sy - sy; yy < TH + sy; yy += sy, row++)
          for (var xx = (s.x * TW) % sx - sx + (row % 2 ? sx / 2 : 0); xx < TW + sx; xx += sx) put(xx, yy);
      } else {
        var rep = s.rep || 1;
        for (var k = 0; k < rep; k++) { var px = ((s.x + k / rep) % 1) * TW; put(px, s.y * TH); if (this.shape === 'cup') { put(px - TW, s.y * TH); put(px + TW, s.y * TH); } }
      }
    }
    x.globalCompositeOperation = 'source-over'; x.globalAlpha = 1;
    if (id === 'top') { x.strokeStyle = 'rgba(0,0,0,.10)'; x.lineWidth = 3; x.strokeRect(6, 6, TW - 12, TH - 12); }
    if (this.sub === 'menu') { x.strokeStyle = 'rgba(255,255,255,.14)'; x.setLineDash([10, 8]); x.lineWidth = 3; x.strokeRect(TW * .035, TH * .025, TW * .93, TH * .95); x.setLineDash([]); }
    if (this.texs[id]) this.texs[id].needsUpdate = true;
    return c;
  };

  /* ---------- Éditeur 2D ---------- */
  P.initStage = function () {
    var self = this;
    this.stage = $('[data-studio-stage]', this.modal);
    this.view2d = $('canvas', this.stage);
    this.sel = $('[data-studio-sel]', this.stage);
    this.safe = $('[data-studio-safe]', this.stage);
    this.guideX = $('[data-guide-x]', this.stage); this.guideY = $('[data-guide-y]', this.stage);
    var drag = null;
    function pt(e) { var r = self.stage.getBoundingClientRect(); return { x: (e.clientX - r.left) / r.width, y: (e.clientY - r.top) / r.height, r: r }; }
    this.stage.addEventListener('pointerdown', function (e) {
      if (!self.logo || !self.state.on) return;
      var h = e.target.closest('[data-h]'), p = pt(e), s = self.state;
      var cx = s.x * p.r.width, cy = s.y * p.r.height, mx = p.x * p.r.width, my = p.y * p.r.height;
      if (h && h.dataset.h === 'rot') drag = { mode: 'rot' };
      else if (h) drag = { mode: 'scale', d0: Math.hypot(mx - cx, my - cy) || 1, w0: s.w };
      else if (e.target.closest('[data-studio-sel]')) drag = { mode: 'move', ox: p.x - s.x, oy: p.y - s.y };
      else { s.x = p.x; s.y = p.y; drag = { mode: 'move', ox: 0, oy: 0 }; self.update(); }
      self.stage.setPointerCapture(e.pointerId); self.stage.classList.add('is-drag'); e.preventDefault();
    });
    this.stage.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var p = pt(e), s = self.state;
      var cx = s.x * p.r.width, cy = s.y * p.r.height, mx = p.x * p.r.width, my = p.y * p.r.height;
      if (drag.mode === 'move') {
        s.x = clamp(p.x - drag.ox, 0, 1); s.y = clamp(p.y - drag.oy, 0, 1);
        var snapX = Math.abs(s.x - .5) < .02, snapY = Math.abs(s.y - .5) < .02;
        if (snapX) s.x = .5; if (snapY) s.y = .5;
        self.guideX.hidden = !snapX; self.guideY.hidden = !snapY;
      } else if (drag.mode === 'scale') { s.w = drag.w0 * Math.hypot(mx - cx, my - cy) / drag.d0; self.fit(); }
      else {
        var a = Math.round(Math.atan2(my - cy, mx - cx) * 180 / PI + 90); if (a > 180) a -= 360;
        [-180, -90, 0, 90, 180].forEach(function (k) { if (Math.abs(a - k) < 4) a = k; });
        s.rot = a;
      }
      self.update();
    });
    function end() { drag = null; self.stage.classList.remove('is-drag'); self.guideX.hidden = self.guideY.hidden = true; }
    this.stage.addEventListener('pointerup', end); this.stage.addEventListener('pointercancel', end);
    this.stage.addEventListener('keydown', function (e) {
      if (!self.logo || !self.state.on) return;
      var s = self.state, st = e.shiftKey ? .05 : .01, k = e.key;
      if (k === 'ArrowLeft') s.x -= st; else if (k === 'ArrowRight') s.x += st;
      else if (k === 'ArrowUp') s.y -= st; else if (k === 'ArrowDown') s.y += st;
      else if (k === '+' || k === '=') { s.w *= 1.05; self.fit(); } else if (k === '-') s.w /= 1.05;
      else if (k === ']') s.rot += 5; else if (k === '[') s.rot -= 5; else return;
      e.preventDefault(); s.x = clamp(s.x, 0, 1); s.y = clamp(s.y, 0, 1); self.update();
    });
    window.addEventListener('resize', function () { if (!self.modal.hidden) self.layoutStage(); });
  };
  P.layoutStage = function () {
    var fd = this.fdims(), wrap = $('[data-studio-stage-wrap]', this.modal), d = this.dims();
    var W = wrap.clientWidth - 32, H = wrap.clientHeight - 56;
    var r = fd.w / fd.h, w = Math.min(W, H * r), h = w / r;
    this.stage.style.width = Math.max(60, w) + 'px'; this.stage.style.height = Math.max(24, h) + 'px';
    this.stage.classList.toggle('is-strip', h < 90);
    this.safe.style.inset = (fd.safe / fd.h * 100) + '% ' + (fd.safe / fd.w * 100) + '%';
    var info = this.faceInfo();
    $('[data-studio-back-lbl]', this.modal).textContent = info.up;
    var size = this.shape === 'cup' ? 'Ø ' + fmt(d.dt) + ' cm · hauteur ' + fmt(d.h) + ' cm'
      : this.shape === 'flat' ? fmt(d.w) + ' × ' + fmt(d.d) + ' cm'
      : this.shape === 'bag' ? fmt(d.w) + ' + ' + fmt(d.d) + ' × ' + fmt(d.h) + ' cm'
      : fmt(d.w) + ' × ' + fmt(d.d) + ' × ' + fmt(d.h) + ' cm';
    $('[data-studio-dims]', this.modal).textContent = size + (this.FACES.length > 1 || this.shape === 'cup' ? ' · ' + info.long + ' : ' + fmt(fd.w) + ' × ' + fmt(fd.h) + ' cm' + (this.shape === 'cup' ? ' (développé)' : '') : '');
    $('[data-studio-face-title]', this.modal).textContent = 'Placez votre logo : ' + info.long.toLowerCase();
  };
  P.update = function () {
    var self = this, s = this.state, fd = this.fdims();
    var c = this.paint();
    var v = this.view2d; if (v.width !== c.width || v.height !== c.height) { v.width = c.width; v.height = c.height; }
    v.getContext('2d').drawImage(c, 0, 0);
    var has = !!this.logo, on = has && s.on;
    this.sel.hidden = !on;
    $('[data-studio-empty]', this.modal).hidden = has;
    $('[data-studio-off]', this.modal).hidden = !has || s.on;
    $$('[data-studio-needs-logo]', this.modal).forEach(function (el) { el.disabled = !on; });
    $('[data-studio-validate]', this.modal).disabled = !has || !this.FACES.some(function (f) { return self.faces[f.id].on; });
    var warn = $('[data-studio-warn]', this.modal);
    if (on) {
      var hFrac = s.w * fd.w * this.aspect / fd.h;
      this.sel.style.left = s.x * 100 + '%'; this.sel.style.top = s.y * 100 + '%';
      this.sel.style.width = s.w * 100 + '%'; this.sel.style.height = hFrac * 100 + '%';
      this.sel.style.transform = 'translate(-50%,-50%) rotate(' + s.rot + 'deg)';
      this.size.value = Math.round(s.w * 100); this.rotIn.value = s.rot;
      var wcm = s.w * fd.w, hcm = wcm * this.aspect;
      $('[data-studio-readout]', this.modal).textContent = this.faceInfo().long + ' · logo ' + fmt(wcm) + ' × ' + fmt(hcm) + ' cm · rotation ' + s.rot + '°' + (s.rep > 1 ? ' · répété ' + s.rep + '×' : '') + (s.tile ? ' · motif répété' : '');
      var rad = s.rot * PI / 180, bw = Math.abs(wcm * Math.cos(rad)) + Math.abs(hcm * Math.sin(rad)), bh = Math.abs(wcm * Math.sin(rad)) + Math.abs(hcm * Math.cos(rad));
      var cx = s.x * fd.w, cy = s.y * fd.h, m = fd.safe;
      var out = !s.tile && this.shape !== 'cup' && (cx - bw / 2 < m - .01 || cx + bw / 2 > fd.w - m + .01) || !s.tile && (cy - bh / 2 < m - .01 || cy + bh / 2 > fd.h - m + .01);
      this.sel.classList.toggle('is-out', !!out);
      warn.hidden = !out; warn.textContent = 'Le logo dépasse la zone imprimable (pointillés, ' + fmt(m) + ' cm des bords).';
    } else { warn.hidden = true; $('[data-studio-readout]', this.modal).textContent = ''; }
    var n = this.colors(), hint = $('[data-studio-colors]', this.modal);
    hint.textContent = n === 1 ? 'Impression 1 couleur : ' + (this.mono ? 'aperçu en 1 couleur.' : 'activez le rendu 1 couleur pour un aperçu fidèle.')
      : n > 1 && n < 4 ? 'Impression ' + n + ' couleurs : le rendu sera adapté à ' + n + ' tons directs lors du BAT.' : '';
    this.dirty = true;
  };

  /* ---------- Vue 3D ---------- */
  P.init3D = function () {
    var self = this, host = $('[data-studio-3d]', this.modal);
    return loadThree().then(function (T) {
      if (self.renderer) return;
      var R = self.renderer = new T.WebGLRenderer({ antialias: true, alpha: true, preserveDrawingBuffer: true });
      R.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
      R.outputEncoding = T.sRGBEncoding; R.shadowMap.enabled = true; R.shadowMap.type = T.PCFSoftShadowMap;
      host.appendChild(R.domElement);
      var sc = self.scene = new T.Scene();
      self.camera = new T.PerspectiveCamera(32, 1, .02, 200);
      sc.add(new T.HemisphereLight(0xffffff, 0xd8cfc4, .75));
      var key = self.key = new T.DirectionalLight(0xffffff, .85); key.position.set(-3, 6, 4); key.castShadow = true;
      key.shadow.mapSize.set(2048, 2048); key.shadow.radius = 6; key.shadow.bias = -.0008; sc.add(key);
      var fill = new T.DirectionalLight(0xffffff, .3); fill.position.set(4, 2, -3); sc.add(fill);
      var ground = new T.Mesh(new T.PlaneGeometry(200, 200), new T.ShadowMaterial({ opacity: .16 }));
      ground.rotation.x = -PI / 2; ground.receiveShadow = true; sc.add(ground);
      var v = self.cam34();
      self.cam = { th: v[0], ph: v[1], dist: 0, tth: v[0], tph: v[1], auto: true };
      self.lidAngle = 0; self.lidTarget = 0;
      var el = R.domElement, drag = null, pinch = null;
      el.addEventListener('pointerdown', function (e) { drag = { x: e.clientX, y: e.clientY, th: self.cam.tth, ph: self.cam.tph }; self.cam.auto = false; el.setPointerCapture(e.pointerId); host.classList.add('is-grab'); });
      el.addEventListener('pointermove', function (e) { if (!drag) return; self.cam.tth = drag.th - (e.clientX - drag.x) * .01; self.cam.tph = clamp(drag.ph + (e.clientY - drag.y) * .008, .05, 1.5); });
      var up = function () { drag = null; host.classList.remove('is-grab'); };
      el.addEventListener('pointerup', up); el.addEventListener('pointercancel', up);
      el.addEventListener('wheel', function (e) { e.preventDefault(); self.cam.zoom = clamp((self.cam.zoom || 1) * (e.deltaY > 0 ? 1.08 : .93), .5, 1.8); }, { passive: false });
      el.addEventListener('touchstart', function (e) { if (e.touches.length === 2) { drag = null; pinch = { d: Math.hypot(e.touches[0].clientX - e.touches[1].clientX, e.touches[0].clientY - e.touches[1].clientY), z: self.cam.zoom || 1 }; } }, { passive: true });
      el.addEventListener('touchmove', function (e) { if (pinch && e.touches.length === 2) { var d = Math.hypot(e.touches[0].clientX - e.touches[1].clientX, e.touches[0].clientY - e.touches[1].clientY); self.cam.zoom = clamp(pinch.z * pinch.d / d, .5, 1.8); } }, { passive: true });
      el.addEventListener('touchend', function () { pinch = null; }, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(function () { self.resize(); }).observe(host);
      self.build(); self.resize(); self.loop();
    });
  };
  P.mats3d = function () {
    var T = window.THREE, self = this, M = MAT[this.material];
    var tex = function (seed) { var t = new T.CanvasTexture(surface(512, 512, self.material, seed)); t.encoding = T.sRGBEncoding; return t; };
    var edgeCol = new T.Color(M.base).multiplyScalar(this.material === 'kraft' ? .82 : M.dark ? .8 : .92);
    var out = {
      side: new T.MeshStandardMaterial({ map: tex(3), roughness: M.leather ? .6 : .92, transparent: !!M.clear, opacity: M.clear ? .82 : 1 }),
      inner: new T.MeshStandardMaterial({ map: tex(5), roughness: .95, color: M.dark ? 0xdddddd : (this.material === 'kraft' ? 0xeee3d6 : 0xf2f0ec), side: T.DoubleSide, transparent: !!M.clear, opacity: M.clear ? .7 : 1 }),
      edge: new T.MeshStandardMaterial({ color: edgeCol, roughness: .95 }),
      face: {}
    };
    this.FACES.forEach(function (f) {
      var c = self.paint(f.id), tx = self.texs[f.id];
      if (!tx) { tx = self.texs[f.id] = new T.CanvasTexture(c); tx.encoding = T.sRGBEncoding; tx.anisotropy = self.renderer.capabilities.getMaxAnisotropy(); }
      else { tx.image = c; tx.needsUpdate = true; }
      if (self.shape === 'cup') { tx.wrapS = T.RepeatWrapping; }
      out.face[f.id] = new T.MeshStandardMaterial({ map: tx, roughness: M.leather ? .55 : .85, side: self.shape === 'cup' ? T.FrontSide : T.FrontSide, transparent: !!M.clear, opacity: M.clear ? .9 : 1 });
    });
    return out;
  };
  P.build = function () {
    var T = window.THREE; if (!T || !this.scene) return;
    if (this.obj) { this.scene.remove(this.obj); this.obj.traverse(function (o) { if (o.geometry) o.geometry.dispose(); }); }
    var d = this.dims(), m = this.mats3d(), g = new T.Group();
    var sh = function (o) { o.castShadow = true; o.receiveShadow = true; return o; };
    var add = function (geo, mats, x, y, z, parent) { var o = sh(new T.Mesh(geo, mats)); o.position.set(x || 0, y || 0, z || 0); (parent || g).add(o); return o; };
    var F = m.face, E = m.edge, S = m.side, I = m.inner, size, lookY;
    this.hinge = null;
    if (this.shape === 'box' || this.shape === 'tray') {
      var W = d.w / 10, D = d.d / 10, H = d.h / 10, t = .012;
      add(new T.BoxGeometry(W, t, D), [E, E, I, S, E, E], 0, t / 2, 0);
      add(new T.BoxGeometry(W, H, t), [E, E, E, E, this.shape === 'box' ? S : F.front, I], 0, H / 2, D / 2 - t / 2 - (this.shape === 'box' ? t : 0));
      add(new T.BoxGeometry(W, H, t), [E, E, E, E, I, F.back], 0, H / 2, -D / 2 + t / 2);
      add(new T.BoxGeometry(t, H, D - 2 * t), [F.right, I, E, E, E, E], W / 2 - t / 2, H / 2, 0);
      add(new T.BoxGeometry(t, H, D - 2 * t), [I, F.left, E, E, E, E], -W / 2 + t / 2, H / 2, 0);
      if (this.shape === 'box') {
        /* couvercle : F.front est porté par le rabat avant du couvercle */
        var hinge = this.hinge = new T.Group(); hinge.position.set(0, H + t / 2, -D / 2); g.add(hinge);
        add(new T.BoxGeometry(W, t, D), [E, E, F.top, I, E, E], 0, 0, D / 2, hinge);
        add(new T.BoxGeometry(W, H * .92, t), [E, E, E, E, F.front, I], 0, -H * .46, D + t / 2, hinge);
        [-1, 1].forEach(function (sg) { add(new T.BoxGeometry(t, H * .8, D * .82), [S, I, E, E, E, E], sg * (W / 2 - t * 2.5), -H * .4, D * .5, hinge); });
        if (this.sub === 'pizza') this.pizza(g, W, D, H, t);
        this.hinge.rotation.x = -this.lidAngle;
      }
      size = Math.max(W, D) * (this.shape === 'tray' ? 1 : 1) + H * .6; lookY = H * .5;
    } else if (this.shape === 'cup') {
      var rt = d.dt / 20, rb = d.db / 20, h = d.h / 10;
      var body = add(new T.CylinderGeometry(rt, rb, h, 96, 1, true, PI, 2 * PI), F.wrap, 0, h / 2, 0);
      add(new T.CylinderGeometry(rt * .985, rb * .985, h * .995, 96, 1, true), I, 0, h / 2 + .002, 0);
      var bottom = add(new T.CircleGeometry(rb * .99, 64), I, 0, h * .03, 0); bottom.rotation.x = -PI / 2;
      var rim = add(new T.TorusGeometry(rt, Math.max(.012, rt * .035), 12, 96), m.edge, 0, h, 0); rim.rotation.x = PI / 2;
      rim.material = new T.MeshStandardMaterial({ color: MAT[this.material].clear ? 0xdfe6ea : 0xf7f6f3, roughness: .6 });
      size = Math.max(h, rt * 2) * 1.45; lookY = h * .5;
    } else if (this.shape === 'bag') {
      var Wb = d.w / 10, Db = d.d / 10, Hb = d.h / 10, tb = .006, cornet = this.sub === 'cornet';
      if (cornet) {
        add(new T.BoxGeometry(Wb, Hb, tb), [E, E, E, E, F.front, I], 0, Hb / 2, Db / 2);
        add(new T.BoxGeometry(Wb, Hb, tb), [E, E, E, E, I, F.back], 0, Hb / 2, -Db / 2);
        add(new T.BoxGeometry(tb, Hb, Db), [S, I, E, E, E, E], Wb / 2, Hb / 2, 0);
        add(new T.BoxGeometry(tb, Hb, Db), [I, S, E, E, E, E], -Wb / 2, Hb / 2, 0);
        this.fries(g, Wb, Db, Hb);
      } else {
        add(new T.BoxGeometry(Wb, Hb, tb), [E, E, E, E, F.front, I], 0, Hb / 2, Db / 2);
        add(new T.BoxGeometry(Wb, Hb, tb), [E, E, E, E, I, F.back], 0, Hb / 2, -Db / 2);
        add(new T.BoxGeometry(tb, Hb, Db), [F.right, I, E, E, E, E], Wb / 2, Hb / 2, 0);
        add(new T.BoxGeometry(tb, Hb, Db), [I, F.left, E, E, E, E], -Wb / 2, Hb / 2, 0);
        add(new T.BoxGeometry(Wb, tb, Db), [E, E, I, S, E, E], 0, tb / 2, 0);
        if (this.handles !== 'none') this.bagHandles(g, Wb, Db, Hb, this.handles);
      }
      size = Math.max(Wb, Hb * 1.15, Db) * 1.05; lookY = Hb * .55;
    } else {
      var Wf = d.w / 10, Df = d.d / 10, th = { mat: .08, menu: .12, napkin: .02, sachet: .025, paper: .004 }[this.sub] || .01;
      var slab = add(new T.BoxGeometry(Wf, th, Df), [E, E, F.recto, (this.sub === 'menu' ? E : S), E, E], 0, th / 2, 0);
      if (this.sub === 'menu') add(new T.BoxGeometry(Wf * .97, th * .7, Df * .97), new T.MeshStandardMaterial({ color: 0xf3efe6, roughness: .9 }), .01, th * .5, 0);
      slab.rotation.y = this.sub === 'mat' ? 0 : -.08;
      size = Math.max(Wf, Df) * .95; lookY = 0;
    }
    this.obj = g; this.scene.add(g);
    this.lookY = lookY; this.cam.dist = size * 2.35;
    var sc = this.key.shadow.camera, b = size * 1.4; sc.left = sc.bottom = -b; sc.right = sc.top = b; sc.near = .1; sc.far = 40; sc.updateProjectionMatrix();
    this.key.position.set(-size * 1.2, size * 3, size * 1.6);
  };
  P.pizza = function (g, W, D, H, t) {
    var T = window.THREE, pz = new T.Group(), rad = Math.min(W, D) * .43;
    var mk = function (geo, col, y) { var o = new T.Mesh(geo, new T.MeshStandardMaterial({ color: col, roughness: .85 })); o.position.y = y; pz.add(o); return o; };
    mk(new T.CylinderGeometry(rad, rad * .98, H * .22, 48), 0xd49a55, 0).castShadow = true;
    mk(new T.CylinderGeometry(rad * .88, rad * .88, H * .05, 48), 0xc0392b, H * .12);
    mk(new T.CylinderGeometry(rad * .8, rad * .8, H * .05, 48), 0xf5d98b, H * .14);
    for (var i = 0; i < 9; i++) { var a = i / 9 * PI * 2 + .3, rr = rad * (i % 2 ? .55 : .3); var s = mk(new T.CylinderGeometry(rad * .09, rad * .09, H * .04, 20), 0x9e2b25, H * .17); s.position.x = Math.cos(a) * rr; s.position.z = Math.sin(a) * rr; }
    pz.position.y = t + H * .11; g.add(pz);
  };
  P.fries = function (g, W, D, H) {
    var T = window.THREE, mat = new T.MeshStandardMaterial({ color: 0xf2c14e, roughness: .7 }), r = 7;
    function rnd() { r = (r * 16807) % 2147483647; return r / 2147483647; }
    for (var i = 0; i < 22; i++) { var f = new T.Mesh(new T.BoxGeometry(.07, H * (.5 + rnd() * .35), .07), mat); f.position.set((rnd() - .5) * W * .8, H * (.75 + rnd() * .15), (rnd() - .5) * D * .7); f.rotation.set((rnd() - .5) * .4, rnd(), (rnd() - .5) * .4); f.castShadow = true; g.add(f); }
  };
  P.bagHandles = function (g, W, D, H, kind) {
    var T = window.THREE, flat = kind === 'flat';
    var col = new T.Color(MAT[this.material].base).multiplyScalar(this.material === 'kraft' ? .95 : 1);
    var mat = new T.MeshStandardMaterial({ color: col, roughness: .9 });
    [1, -1].forEach(function (sg) {
      var hw = W * (flat ? .2 : .17), hh = H * .28;
      var pts = [new T.Vector3(-hw, H - .15, 0), new T.Vector3(-hw * .95, H + hh * .7, 0), new T.Vector3(0, H + hh, 0), new T.Vector3(hw * .95, H + hh * .7, 0), new T.Vector3(hw, H - .15, 0)];
      var tube = new T.Mesh(new T.TubeGeometry(new T.CatmullRomCurve3(pts), 48, flat ? .09 : .025, flat ? 4 : 10, false), mat);
      if (flat) tube.scale.z = .12;
      tube.position.z = sg * (D / 2 - .01); tube.castShadow = true; g.add(tube);
    });
  };
  P.resize = function () {
    if (!this.renderer) return;
    var host = $('[data-studio-3d]', this.modal), w = host.clientWidth, h = host.clientHeight;
    if (!w || !h) return;
    this.renderer.setSize(w, h, false); this.camera.aspect = w / h; this.camera.updateProjectionMatrix(); this.dirty = true;
  };
  P.place = function (th, ph, zoom) {
    var dist = this.cam.dist * (zoom || 1) * Math.max(1, 1.3 / this.camera.aspect), ly = this.lookY || 0;
    this.camera.position.set(Math.sin(th) * Math.cos(ph) * dist, ly + Math.sin(ph) * dist, Math.cos(th) * Math.cos(ph) * dist);
    this.camera.lookAt(0, ly, 0);
  };
  P.loop = function () {
    var self = this;
    function tick() {
      if (self.modal.hidden) { self.raf = null; return; }
      self.raf = requestAnimationFrame(tick);
      var c = self.cam, k = reduce ? 1 : .12;
      if (c.auto && !reduce) c.tth += .0035;
      var moving = Math.abs(c.tth - c.th) > .0005 || Math.abs(c.tph - c.ph) > .0005 || Math.abs(self.lidTarget - self.lidAngle) > .001 || c.auto;
      c.th += (c.tth - c.th) * k; c.ph += (c.tph - c.ph) * k;
      self.lidAngle += (self.lidTarget - self.lidAngle) * (reduce ? 1 : .09);
      if (!moving && !self.dirty && self._z === c.zoom) return;
      self._z = c.zoom; self.dirty = false;
      if (self.hinge) self.hinge.rotation.x = -self.lidAngle;
      self.place(c.th, c.ph, c.zoom);
      self.renderer.render(self.scene, self.camera);
    }
    if (!this.raf) tick();
  };
  P.view = function (v) {
    if (!this.cam) return; this.cam.auto = false;
    this.aim(v === 'top' ? [0, 1.5] : v === 'front' ? [0, this.shape === 'flat' ? .5 : .22] : this.cam34());
    $$('[data-studio-view]', this.modal).forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.studioView === v); });
  };
  P.toggleLid = function () {
    this.lidOpen = !this.lidOpen; this.lidTarget = this.lidOpen ? 1.95 : 0;
    $('[data-studio-lid]', this.modal).textContent = this.lidOpen ? 'Fermer la boîte' : 'Ouvrir la boîte';
    if (this.cam) this.cam.auto = false;
  };
  P.rebuild = function () {
    var self = this; this.FACES.forEach(function (f) { self.fit(f.id); self.paint(f.id); });
    this.layoutStage(); this.update(); if (this.renderer) { this.build(); this.dirty = true; }
  };

  /* ---------- Ouverture / fermeture ---------- */
  P.open = function () {
    var self = this;
    this.lastFocus = document.activeElement;
    this.modal.hidden = false; document.documentElement.style.overflow = 'hidden';
    $$('[data-studio-mat]', this.modal).forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.studioMat === self.material); });
    if (!this._monoInit) {
      this._monoInit = true; this.autoInk();
      if (this.colors() === 1) this.mono = true;
      $('[data-studio-mono]', this.modal).checked = this.mono; this.refreshLogo();
    }
    this.renderInks(); this.renderFaces();
    requestAnimationFrame(function () {
      self.modal.classList.add('is-open');
      self.layoutStage(); self.update();
      var f = $(self.logo ? '[data-studio-stage]' : '[data-studio-upload]', self.modal); if (f) f.focus({ preventScroll: true });
    });
    var ld = $('[data-studio-loading]', this.modal); ld.hidden = !!this.renderer;
    this.init3D().then(function () { ld.hidden = true; self.build(); self.resize(); self.dirty = true; self.loop(); })
      .catch(function () { ld.hidden = false; ld.textContent = 'La vue 3D n\'a pas pu se charger. Le placement 2D reste disponible.'; });
  };
  P.close = function () {
    this.modal.classList.remove('is-open'); this.modal.hidden = true;
    document.documentElement.style.overflow = '';
    if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
  };

  /* ---------- Validation : propriétés de commande + aperçus ---------- */
  P.validate = function () {
    var self = this, d = this.dims();
    if (!this.logo) return;
    var on = this.FACES.filter(function (f) { return self.faces[f.id].on; });
    if (!on.length) return;
    var lines = on.map(function (f) {
      var s = self.faces[f.id], fd = self.fdims(f.id), wcm = s.w * fd.w, hcm = wcm * self.aspect;
      return f.long + ' (' + fmt(fd.w) + '×' + fmt(fd.h) + ' cm) : logo ' + fmt(wcm) + '×' + fmt(hcm) + ' cm, centre à ' + fmt(s.x * fd.w) + ' cm du bord gauche et ' + fmt(s.y * fd.h) + ' cm du ' + (f.id === 'top' ? 'bord arrière' : 'haut') + ', rotation ' + s.rot + '°' + (s.rep > 1 ? ', répété ' + s.rep + '×' : '') + (s.tile ? ', motif répété' : '');
    });
    var txt = lines.join(' | ') + ' · support ' + MAT[this.material].label.toLowerCase() + (this.mono ? ' · aperçu 1 couleur (' + this.ink.name + ')' : '');
    if (this.propInput) { this.propInput.value = txt; this.propInput.disabled = false; }
    if (this.facesInput) { this.facesInput.value = on.map(function (f) { return f.long; }).join(', '); this.facesInput.disabled = false; }
    /* instantané 3D pour la galerie */
    var shot = null;
    if (this.renderer) {
      this.lidTarget = this.lidAngle = 0; if (this.hinge) this.hinge.rotation.x = 0;
      var v = this.cam34(); this.place(this.shape === 'bag' || this.shape === 'cup' ? -.35 : v[0], this.shape === 'box' && on.length > 1 ? .45 : v[1], 1);
      this.renderer.render(this.scene, this.camera); try { shot = this.renderer.domElement.toDataURL('image/png'); } catch (e) {}
      this.dirty = true;
    }
    /* planche d'aperçu : toutes les faces imprimées, à l'échelle */
    var PW = 1200, pad = 24, maxW = Math.max.apply(null, on.map(function (f) { return self.fdims(f.id).w; }));
    var scale = (PW - 2 * pad) / maxW, y = 70, blocks = [];
    on.forEach(function (f) { var fd = self.fdims(f.id), bw = fd.w * scale, bh = Math.min(fd.h * scale, 1400); blocks.push({ f: f, bw: bw, bh: bh, y: y + 26 }); y += bh + 56; });
    var out = document.createElement('canvas'); out.width = PW; out.height = y + 60;
    var x = out.getContext('2d'); x.fillStyle = '#fff'; x.fillRect(0, 0, out.width, out.height);
    x.fillStyle = '#1d1d1f'; x.font = '600 26px system-ui, Arial'; x.fillText('Kornerprint · aperçu de placement (non contractuel)', pad, 40);
    blocks.forEach(function (b) {
      x.font = '600 18px system-ui, Arial'; x.fillStyle = '#1d1d1f'; x.fillText(b.f.long, pad, b.y - 8);
      x.drawImage(self.paint(b.f.id), pad, b.y, b.bw, b.bh); x.strokeStyle = 'rgba(0,0,0,.25)'; x.lineWidth = 1; x.strokeRect(pad, b.y, b.bw, b.bh);
    });
    x.font = '15px system-ui, Arial'; x.fillStyle = '#555';
    x.fillText(($('[data-studio-dims]', this.modal).textContent || '').split(' · ')[0] + ' · support ' + MAT[this.material].label.toLowerCase() + ' · ' + this.logoName.slice(0, 60), pad, out.height - 24);
    out.toBlob(function (blob) {
      if (blob && self.proofInput) {
        try { var dt = new DataTransfer(); dt.items.add(new File([blob], 'apercu-placement.jpg', { type: 'image/jpeg' })); self.proofInput.files = dt.files; self.proofInput.disabled = false; } catch (e) {}
      }
    }, 'image/jpeg', .9);
    var done = $('[data-studio-done]', this.root);
    if (done) {
      done.hidden = false;
      $('img', done).src = shot || this.paint(on[0].id).toDataURL('image/jpeg', .8);
      $('[data-studio-summary]', done).textContent = on.length === 1 ? on[0].long : on.length + ' faces : ' + on.map(function (f) { return f.label.toLowerCase(); }).join(', ');
    }
    this.cta.classList.add('is-done');
    var main = $('.kp-gallery__main img', this.root);
    if (main && shot) { main.srcset = ''; main.src = shot; main.closest('.kp-gallery__main').classList.add('is-3d'); }
    this.close();
    this.toast('Personnalisation enregistrée ✓');
  };

  function init(scope) {
    $$('[data-kp-studio-section]', scope || document).forEach(function (sec) {
      if (sec._studio) return;
      var root = $('[data-kp-product]'); if (!root) return;
      var cta = $('[data-kp-studio]', sec), form = $('form[data-kp-ajax-add]', root); if (!cta || !form) return;
      /* le bouton et ses champs rejoignent le formulaire, juste sous le dépôt de logo */
      var up = $('.kp-upload', form);
      if (up) up.parentNode.insertBefore(cta, up.nextSibling);
      else { var pb = $('.kp-price-box', form); form.insertBefore(cta, pb || null); }
      sec._studio = new Studio(root, cta, $('[data-studio-modal]', sec));
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
